import React, {FC, ReactNode} from 'react';
import {ErrorBoundaryFallback, ErrorBoundaryProps} from './loggers';
import {ErrorBoundary} from './loggers/error-boundary/ErrorBoundaryMinimal';

/**
 * GlobalErrorBoundary component that provides the the default error view for errors that occur in the application.
 */
export const GlobalErrorBoundary: FC<
  {
    children?: ReactNode;
  } & ErrorBoundaryProps
> = ({children, errorBoundaryTexts}) => {
  return (
    <ErrorBoundary
      ErrorComponent={() => (
        <ErrorBoundaryFallback errorBoundaryTexts={errorBoundaryTexts} />
      )}
    >
      {children}
    </ErrorBoundary>
  );
};
